import type { QueryParamConfig } from 'serialize-query-params';

import type { ScalarBuilder } from '@packages/query-broker/operation-builder';
import { scalar } from '@packages/query-broker/operation-builder';

export const ScalarBuilderQueryParam: QueryParamConfig<
  Array<ScalarBuilder> | undefined
> = {
  decode: (scalarValue) => {
    if (!scalarValue) {
      return undefined;
    }
    if (!Array.isArray(scalarValue)) {
      return [scalar(scalarValue)];
    }

    return scalarValue
      .filter((val) => val != null)
      .reduce<
        Array<ScalarBuilder>
      >((acc, value) => [...acc, scalar(value)], []);
  },
  encode: (scalarValues) => {
    if (scalarValues == null) {
      return undefined;
    }

    return scalarValues.map((builder) =>
      builder.build().scalar.value.toString(),
    );
  },
};
